/* eslint-disable object-shorthand */

export var PACKAGE_BUILD_DATE = '2026-11-04T07:30:42.928Z';
export var PACKAGE_NAME = 'invision-customercare';
export var PACKAGE_VERSION = '26.4.10002-2700214';
export default {
  PACKAGE_BUILD_DATE: PACKAGE_BUILD_DATE,
  PACKAGE_NAME: PACKAGE_NAME,
  PACKAGE_VERSION: PACKAGE_VERSION
};